/**
 * R12.1-FE: Time tracking + geofencing API.
 */

import { http } from './http';
import type {
  ClockRequestDto,
  ClockEventResponseDto,
  ClockStatusResponseDto,
  DailySummaryResponseDto,
  WorksiteAttendanceReportEntryDto,
} from './types';

export const attendanceApi = {
  getStatus(): Promise<ClockStatusResponseDto> {
    return http.get<ClockStatusResponseDto>('/attendance/status').then((r) => r.data);
  },

  clockIn(dto: ClockRequestDto): Promise<ClockEventResponseDto> {
    return http.post<ClockEventResponseDto>('/attendance/clock-in', dto).then((r) => r.data);
  },

  clockOut(dto: ClockRequestDto): Promise<ClockEventResponseDto> {
    return http.post<ClockEventResponseDto>('/attendance/clock-out', dto).then((r) => r.data);
  },

  getDaily(date: string): Promise<DailySummaryResponseDto> {
    return http
      .get<DailySummaryResponseDto>('/attendance/daily', { params: { date } })
      .then((r) => r.data);
  },

  getWorksiteReport(params: {
    worksiteId: string;
    dateFrom: string;
    dateTo: string;
  }): Promise<WorksiteAttendanceReportEntryDto[]> {
    return http
      .get<WorksiteAttendanceReportEntryDto[]>(`/attendance/worksite/${params.worksiteId}`, {
        params: { dateFrom: params.dateFrom, dateTo: params.dateTo },
      })
      .then((r) => r.data);
  },
};
